<template>
  <div>

    <div class="stepschronological is-margin-bottom-xsmall">
      <div class="stepschronological-item is-valid">
        <div class="stepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="stepschronological-item-info">
          <span class="is-uppercase">Passage en reservation</span>
          <div class="stepschronological-item-info-sub">
            <span class="is-uppercase">Le {{adv.reservation_date | date}}</span>
          </div>
        </div>
      </div>
      <div class="stepschronological-item" :class="{'is-valid' : signatureContratCheck}">
        <div class="stepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="stepschronological-item-info">
          <span class="is-uppercase">Signature contrat de réservation</span>
          <span v-if="!signatureContratCheck" class="stepschronological-item-info-sub">
            En attente de signature
          </span>
          <span v-else class="stepschronological-item-info-sub">
            <span class="is-uppercase">Le {{adv.signature_date | date}}</span>
          </span>
        </div>
      </div>
      <div class="stepschronological-item" :class="{'is-valid' : financementCheck}">
        <div class="stepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="stepschronological-item-info">
          <span class="is-uppercase">Financement validé</span>
          <a v-if="!financementCheck" href="#" @click="goFinancement" class="stepschronological-item-info-sub">
            Renseigner
          </a>
          <a v-else href="#" @click="goFinancement" class="stepschronological-item-info-sub">
            Consulter
          </a>
        </div>
      </div>
      <div class="stepschronological-item" :class="{'is-valid' : signatureActeCheck}">
        <div class="stepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="stepschronological-item-info">
          <span class="is-uppercase">Signature acte</span>

          <span v-if="signatureActeCheck" class="stepschronological-item-info-sub">
             <span class="is-uppercase">Le {{adv.sale_date | date}}</span>
          </span>
          <router-link v-else-if="isAdmin || isSectorManager"
                       :to="{name: 'Notaire', params: {id: this.advPk}, query: {acte: true}}"
                       class="stepschronological-item-info-sub">
            Renseigner
          </router-link>
          <router-link v-else
                       :to="{name: 'Notaire', params: {id: this.advPk}, query: {acte: true}}"
                       class="stepschronological-item-info-sub">
            Consulter
          </router-link>
        </div>
      </div>
      <div v-if="isCanceled"
           class="stepschronological-item"
      >
        <div class="stepschronological-item-visuel">
          <div><span class="icon is-large is-size-2"><i class="fas fa-check-circle"></i></span></div>
        </div>
        <div class="stepschronological-item-info">
          <span class="is-uppercase">Date d'annulation</span>
          <div class="stepschronological-item-info-sub">
            <span v-if="adv.cancel_date">{{adv.cancel_date | date}}</span>
            <span v-else>NC</span>
          </div>
        </div>
      </div>
    </div><!-- /.stepschronological -->

    <div class="columns is-gapless is-multiline is-margin-neg-left-xxsmall is-margin-neg-right-xxsmall">
      <div class="column is-12 is-7-widescreen is-7-fullhd is-self-flex-start is-padding-left-xxsmall is-padding-right-xxsmall is-padding-top-xxsmall">
        <div class="is-border has-bg-white is-height-full">
          <div class="has-bg-light">
            <div class="columns is-gapless is-vcentered is-multiline is-min-height-50 is-padding-top-xxsmall is-padding-bottom-xxsmall">
              <div v-if="adv.destination" class="column is-narrow is-padding-left is-uppercase is-size-6">
                <span class="has-text-grey">Destination :</span> <b>{{adv.destination | contactResearchLabel}}</b>
              </div>
              <div class="column is-narrow is-padding-left is-uppercase is-size-6"
                   v-if="adv.tax_dispositif && !isParking">
                <span class="has-text-grey">Dispositif :</span> <b>{{adv.tax_dispositif | taxDispositifLabel}}</b>
              </div>
              <div class="column is-narrow is-padding-left is-uppercase is-size-6"
                   v-if="adv.destination && adv.destination === 'invest'">
                <div class="columns is-vcentered">
                  <div class="column is-paddingless is-narrow is-margin-right-small">
                    <label class="has-text-grey is-size-6 is-uppercase" for="mandatDeGestion">Mandat de gestion
                      :</label>
                  </div>
                  <div class="column is-paddingless" v-if="isAdmin || isSectorManager">
                    <div class="field">
                      <div class="select is-transparent is-small is-paddingless-left">
                        <select class="has-text-weight-medium" v-model="mandatDeGestion"
                            @input="updateMandat"
                            id="mandatDeGestion">
                          <option :value="null">NC</option>
                          <option :value="true">Oui</option>
                          <option :value="false">Non</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <b v-if="mandatDeGestion">Oui</b>
                    <b v-else-if="mandatDeGestion === false">Non</b>
                    <b v-else-if="mandatDeGestion === null">NC</b>
                  </div>
                </div>
              </div>
              <div class="column is-narrow is-padding-left is-uppercase is-size-6"
                   v-if="mandatDeGestion === true && !loading && (isAdmin || isSectorManager)">
                <div v-if="adv.mandat_de_gestion_file !== null">
                  <a @click="goToLink('AdvDocuments')" class="is-underline is-italic">
                    Mandat de gestion
                  </a>
                </div>
                <div v-else>
                  <label class="button is-white is-rounded is-size-6"
                         style="text-transform: none; color: black; border-color: #e8e8e8;">
                    <input class="file-input" type="file" name="file" @change="fileChange($event.target.files)"/>
                    Télécharger mandat de gestion
                  </label>
                </div>
              </div>
              <div class="column is-narrow is-paddingless-top is-paddingless-right is-self-centered"
                   v-else-if="loading">
                <i class="fas fa-spinner fa-spin is-margin-xsmall"></i>
              </div>
            </div>
          </div>

          <div class="columns is-gapless is-min-height-50 is-border-top">
            <div class="column is-padding-left is-padding-right is-self-centered">
              <span class="is-uppercase title is-6">Vendeur(s) / Mandataire(s)</span>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical" v-if="isAdmin || isSectorManager">
              <div class="is-min-height-full"><!-- seulement à ajouter quand il y a un seul élément-->
                <button @click="goToTauxDeCom" class="tooltip is-tooltip-left"
                        data-tooltip="Ajouter un vendeur ou mandataire">
                  <span class="icon"><i class="fas fa-user-plus"></i></span>
                </button>
              </div>
            </div>
          </div>

          <template v-for="(share, i) in shares" v-if="share.seller === currentUserPk || isAdmin || isSectorManager || isManager">
            <div v-if="shares && shares.length" :key="share.seller"
                 class="has-bg-grey3 columns has-text-primary is-multiline is-padding-top-small is-padding-bottom-small is-border-top">
              <div class="columns column is-12 is-8-fullhd is-gapless is-vcentered">
                <div class="column is-narrow is-margin-right-xsmall">
                  <avatar :item="share" :i="i" :classes="avatarColor"></avatar>
                </div>
                <div class="column">
                  <b>{{share.seller_name}}</b>
                  <br>
                  <span v-if="share.company">Société {{share.company_name}}</span>

                  <span class=""
                        v-if="(share.remuneration || share.total_rem_ht) && displayRemuneration && (isAdmin || isSectorManager || isManager || share.seller == currentUserPk)">
                  <span v-if="share.remuneration" class="is-size-6">
                    (COMM : {{share.remuneration}}% :
                    <span v-if="share.total_rem_ht">{{Number(share.total_rem_ht).toFixed(2)}} {{$currency}} HT <a
                      v-if="isAdmin || isSectorManager" class="is-underline" @click="goToTauxDeCom">- Modifier</a>)</span>
                  </span>
                </span>
                  <div v-if="share.total_bonus_ht && displayRemuneration">
                    <span class="is-size-6 is-uppercase">Bonus : <span
                      class="is-size-6">{{share.total_bonus_ht}} {{$currency}}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </template>


          <div class="columns is-gapless is-min-height-50 is-border-top is-border-bottom">
            <div class="column is-padding-left is-padding-right is-self-centered">
              <span class="is-uppercase title is-6">Réservataire(s) / Acquéreur(s)</span>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="dropdown is-hoverable is-right">
                <div class="dropdown-trigger w100">
                  <button aria-haspopup="true" aria-controls="dropdown-menu"
                          :data-tooltip="!canAdd ?'Vous avez atteint la limite maximum de 3 acquéreurs' : ''"
                          :class="{'tooltip is-tooltip-left is-tooltip-primary': !canAdd}" class="">
                    <span class="icon"><i class="far fa-ellipsis-v"></i></span>
                  </button>
                </div>
                <div role="menu" class="dropdown-menu" v-if="canAdd">
                  <div class="dropdown-content has-text-left">
                    <a @click="openBuyerSelection" class="dropdown-item">
                      <span class="icon"><i class="fas fa-user"></i></span> Sélectionner un co-acquéreur
                    </a>
                    <router-link :to="{name: 'ContactCreate', query: {next: $route.path}}" class="dropdown-item">
                      <span class="icon"><i class="fas fa-user-plus"></i></span> Créer un co-acquéreur
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <membre-adv @goToContact="goToContact" :is-grey="true" :is-check="checkCompleteBuyer(buyer)" :membre="buyer" :is-promoteur="false" :is-co-acquereur="false" :modal-promoteur="false"></membre-adv>

          <template v-if="coBuyers && coBuyers.length" v-for="coBuyer in coBuyers">
            <membre-adv @goToContact="goToContact" @DeleteCobuyer="beforeRemove" :is-grey="true" :key="coBuyer.pk" :is-check="checkCompleteBuyer(coBuyer)" :membre="coBuyer" :is-promoteur="false" :is-co-acquereur="true" :modal-promoteur="false"></membre-adv>
          </template>

          <div class="columns is-gapless is-min-height-50" v-if="isAdmin || isSectorManager">
            <div class="column is-padding-left is-padding-right is-self-centered">
              <span class="is-uppercase title is-6">
                Commentaire{{comments.length > 0 ? 's' : ''}} ({{comments.length}})</span>
              <span v-helper.bottomLeft="'4ineXe3kDxAMbiIio3IjWT'">
                <i class="fal fa-info-circle fa-xs"></i>
              </span>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="is-min-height-full">
                <button @click="openComment = !openComment">
                  <span class="icon"><i :class="openComment ? 'far fa-chevron-up' : 'far fa-chevron-down'"></i></span>
                </button>
              </div>
            </div>
          </div>

          <div v-show="(isAdmin || isSectorManager) && openComment">
            <div v-for="(c, iii) in comments" :key="c.pk"
              :ref="'commentWrapper-' + c.pk">
              <adv-comment
                :idx="iii"
                :ref="'comment-' + c.pk"
                :comment="c"
                @editComment="editAdvComment"
                @removeComment="removeAdvComment"
                :class="['is-border-top', iii < comments.length-1 ? 'is-border-bottom' : '']"
              ></adv-comment>
            </div>
            <div v-if="(isAdmin || isSectorManager) && showNewCommentEditor" class="columns is-gapless is-border-top">
              <div class="column">
                <wysiwyg-editor
                  :light='true' :tooltip-top="true"
                  @change="val => newCommentMessage = val"
                  class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless"
                >
                </wysiwyg-editor>
              </div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div>
                  <button class="button is-success" type="button" @click="addComment">
                    <span class="icon is-small has-text-white"><i class="fal fa-save"></i></span>
                  </button>
                </div>
                <div class="">
                  <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="showNewCommentEditor = false">
                    <span class="icon is-small"><i class="fal fa-times"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!showNewCommentEditor && (isAdmin || isSectorManager)" class="row-width-actions-bar">
            <button @click="openCommentEditor" class="page-header-btn button is-grey-dark is-fullwidth is-radiusless">
              <span>Ajouter un Commentaire</span>
            </button>
          </div>
        </div>
      </div>

      <div class="column is-12 is-5-widescreen is-5-fullhd is-order-first-desktop is-order-2-widescreen is-padding-left-xxsmall is-padding-right-xxsmall is-padding-top-xxsmall">
        <div class=" has-bg-white is-border">

          <div v-if="adv.custom_price_name" class="has-bg-light is-padding">
            <span class="is-uppercase">Prix pack : </span><span
            class="has-text-weight-medium">{{adv.custom_price_name}}</span>
            <br>
            <b v-if="adv.custom_price_description" class="is-size-6" v-html="adv.custom_price_description"></b>
          </div>

          <div :class="{'is-border-top' : !adv.custom_price_name}"
               class="has-bg-light columns is-gapless is-padding-top-small is-padding-bottom-xsmall">
            <div class="column is-padding-left is-3">
              <label for="" class="label">Prix de vente lot HT</label>
            </div>
            <div class="column is-padding-left is-3">
              <label for="" class="label">TVA</label>
            </div>
            <div class="column is-padding-left">
              <label for="" class="label">Prx de vente TTC</label>
            </div>
          </div>
          <div v-if="!modification"
               class="has-bg-reserve is-border-top columns is-vcentered is-gapless is-min-height-50 has-text-white"><!-- has-bg-white-bis-darken-1 -->
            <div class="column is-padding-left is-3">
              <b class="is-size-4"><span v-if="adv.sale_price_ht_with_discount">{{adv.sale_price_ht_with_discount | prettyPrice}}</span><span
                v-else>{{adv.sale_price_ht | prettyPrice}}</span> {{$currency}} HT</b>
            </div>
            <div class="column is-padding-left is-3">
              <b class="is-size-4">{{adv.tva}} % </b><span class="is-size-5">({{adv.sale_price_with_discount - adv.sale_price_ht_with_discount | prettyPrice}}{{$currency}})</span>
            </div>
            <div class="column is-padding-left">
              <b class="is-size-4"><span v-if="adv.sale_price_with_discount">{{adv.sale_price_with_discount | prettyPrice}}</span><span
                v-else>{{adv.sale_price | prettyPrice}}</span> {{$currency}} TTC</b>
            </div>
            <div class="column is-narrow is-self-stretched" v-if="isAdmin || isSectorManager">
              <button @click="modification = true"
                      class="button is-small is-white-ter is-transform-none is-padding-left-small is-padding-right-small is-min-width-0 is-height-full is-radiusless">
                <span class="">Modifier</span>
              </button>
            </div>
          </div>
          <div v-else class="has-bg-white-bis-darken-1 is-border-top columns is-vcentered is-gapless is-min-height-50">
            <div class="column is-padding-left is-3">
              <b class="is-size-4"><span v-if="adv.sale_price_ht_with_discount">{{adv.sale_price_ht_with_discount | prettyPrice}}</span><span
                v-else>{{adv.sale_price_ht | prettyPrice}}</span> {{$currency}} HT</b>
            </div>
            <div class="column is-padding-left is-3">
              <b class="is-size-4">{{adv.tva}} % </b><span class="is-size-5">({{adv.sale_price_with_discount - adv.sale_price_ht_with_discount | prettyPrice}} {{$currency}})</span>
            </div>
            <div class="column is-padding-left">
              <div class="field has-addons">
                <div class="control">
                  <v-input id="sale_price_with_discount" name="sale_price_with_discount"
                           @input="val => adv.sale_price_with_discount = val" :model="adv.sale_price_with_discount"
                           class=""
                           v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val" :number='true'
                           input-type="number"
                           data-vv-as="">
                  </v-input>
                </div>
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-padding-left-xsmall is-padding-right-xsmall">
                    <span class="icon is-small" :class="`is-currency-${$faCurrency}`"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                    <span>TTC</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-narrow is-padding-left is-self-stretched">
              <button @click="saveSalePrice"
                      class="button is-smalll is-success is-transform-none is-min-width-0 is-height-full is-radiusless">
                <span class="icon is-small"><i class="fas fa-save"></i></span>
              </button>
            </div>
          </div>
          <div class="is-border-top has-bg-light is-padding-left is-padding-top-small is-padding-bottom-small"
               v-if="adv.sale_price_with_discount && adv.sale_price_with_discount !== adv.sale_price"
          >
            <span class="has-text-danger is-uppercase has-text-weight-medium">Prix initial : {{adv.sale_price|prettyPrice}} {{$currency}} TTC </span>
          </div>

          <div v-if="adv.parkings && adv.parkings.length"
               class="has-bg-white is-border-top is-border-bottom is-padding-top-xsmall is-padding-bottom">
            <div class="is-padding-left">
              <b v-if="adv.parkings.length === 1" class="is-size-6">Dont prix du parking</b>
              <b v-else class="is-size-6">Dont prix des parkings</b>
            </div>
            <template v-for="(parking, idx) in adv.parkings">
              <div :key="idx" class="columns is-gapless is-multiline is-padding-top-small">
                <div class="column is-12 is-padding-left">
                  <span class="is-size-6">Parking {{parking.annex_type}} <span v-if="parking.info">({{parking.info}})</span></span>
                </div>
                <div class="column is-padding-left is-3">
                  <b class="is-size-6">{{parking.sale_price_ht}} {{$currency}} HT</b>
                </div>
                <div class="column is-padding-left is-3">
                  <b class="is-size-6">TVA : {{parking.tva}} % ({{parking.sale_price - parking.sale_price_ht| prettyPrice}} {{$currency}})</b>
                </div>
                <div class="column is-padding-left">
                  <b class="is-size-6">{{parking.sale_price}} {{$currency}} TTC</b>
                </div>
              </div>
            </template>
          </div>

          <adv-lot-compact :lot="lot" :program="program" v-if="lot && program" :display-button="false"/>

        </div>
      </div>

      <div v-if="canEdit && pendingEdition"
           class="column is-12 is-7-widescreen is-7-fullhd is-order-3-desktop formActionsSticky is-bottom is-zindex-2 is-padding-left-xxsmall is-padding-right-xxsmall"
      >
        <div class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
          <div class="column is-5 is-4-widescreen is-margin-right-small">
            <button class="button is-light is-fullwidth is-min-height-50 is-transform-none has-text-weight-medium"
                    @click="backToInitialAdv">Annuler
            </button>
          </div>
          <div class="column is-5 is-4-widescreen is-margin-left-small">
            <button class="button is-success is-fullwidth is-min-height-50 is-transform-none has-text-weight-medium"
                    @click="saveAdv">
              <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"
                          mode="out-in">
                <div v-if="saving" key="saving" class="veryFastAnimation" is-success>
                  <span class="has-text-black">Enregistrement...</span>
                </div>
                <div v-else key="not-saving" class="veryFastAnimation">
                  <span>Enregistrer</span>
                </div>
              </transition>
            </button>
          </div>
        </div>
      </div>
      <div v-if="isAdmin || isSectorManager && events && events.length > 0"
        class="column is-12 is-7-widescreen is-7-fullhd is-order-3-desktop is-padding-left-xxsmall is-padding-right-xxsmall"
      >
        <event-tracker-list v-if="isAdmin || isSectorManager"
          :show-list="showLastEvents"
          :events="lastEvents" :last-event="lastEvent"
          :show-all="!!fullHistory && !!fullHistory.length"
          @showAll="getFullHistory"
          @toggle="showLastEvents = !showLastEvents">
        </event-tracker-list>
      </div>

    </div>
  </div>
</template>

<script>
  import { DefaultValues, DownloadFile, AdvMx, EventTrackerMx } from '@/mixins'
  import { isObject, remove } from 'lodash'
  import { mapState } from 'vuex'
  import AdvLot from './AdvLot'
  import AdvLotCompact from './AdvLotCompact'
  import AdvComment from '../AdvComment'
  import MembreAdv from '../MembreAdv'

  export default {
    name: 'AdvInfos',
    mixins: [DefaultValues, DownloadFile, AdvMx, EventTrackerMx],
    components: { AdvComment, AdvLot, AdvLotCompact, MembreAdv },
    data () {
      return {
        mandatDeGestion: null,
        helper: 'Commentaires privés, réservé aux admins',
        service: this.$api.advService,
        modification: false,
        openComment: true,
        isLight: true,
        wysiOpen: false,
        modifComment: false,
        displayButton: true,
        loading: false,
        uploaded: false,
        files: null,
        progressData: 0,
        uploadingNumber: 0,
        loadingComments: false,
        newCommentMessage: null,
        showNewCommentEditor: false,
        comments: []
      }
    },
    watch: {
      // 'adv.mandat_de_gestion' () {
      //   this.editAdv(true)
      // },
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'CONTACT_SELECTION') {
            results.entities.forEach(x => {
              this.addCoBuyer(x)
            })
          } else if (mode === 'SELLER_SELECTION') {
            results.entities.forEach(x => {
              this.addSeller(x)
            })
          }
        }
      }
    },
    computed: {
      eventEntity () {
        return this.adv
      },
      ...mapState(['quickview']),
      shares () {
        return this.sourceShares
      },
      taxDispositifs () {
        if (this.lot && this.lot.tax_dispositifs && this.lot.tax_dispositifs.length && this.taxDispositifsData) {
          return this.lot.tax_dispositifs.map(x => this.taxDispositifsData[x].label).join(', ')
        }
      },
      statusBarColor () {
        const COLORS = {
          'canceled_by_admin': 'has-status-bar--draft',
          'reserved': 'has-status-bar--reserve',
          'optioned': 'has-status-bar--optionne'
        }
        return COLORS[this.status]
      },
      avatarColor () {
        const COLORS = {
          'canceled_by_admin': 'has-bg-draft',
          'reserved': 'has-bg-reserve',
          'optioned': 'has-bg-optionne'
        }
        return COLORS[this.status]
      },
      canAdd () {
        return this.adv.co_buyers.length <= 1
      },
      financementCheck () {
        if (!this.financement.use_loan) {
          return true
        } else {
          let loans = []
          this.adv.financement.loans.forEach(loan => {
            if (loan.bank_name !== null && loan.bank_name !== '' &&
              loan.depot_de_dossier !== null && loan.depot_de_dossier !== '' &&
              loan.edition_de_l_offre !== null && loan.edition_de_l_offre !== '' &&
              loan.loan_apport !== null && loan.loan_apport !== '' &&
              loan.loan_type !== null && loan.loan_type !== '' &&
              loan.loan_value !== null && loan.loan_value !== '' &&
              loan.signature_de_l_offre !== null && loan.signature_de_l_offre !== '') loans.push(loan)
          })
          if (this.adv.financement.loans && this.adv.financement.loans.length && loans.length === this.adv.financement.loans.length) {
            return true
          } else {
            return false
          }
        }
      },
      signatureActeCheck () {
        if (this.adv.sale_date) return true
      },
      signatureContratCheck () {
        if (this.adv.signature_date) return true
      },
      events () {
        return this.adv.events
      }
    },
    methods: {
      updateMandat () {
        this.$set(this.adv, 'mandat_de_gestion', this.mandatDeGestion)
        setTimeout(() => {
          this.editAdv(true)
        }, 100)
      },
      async loadComments () {
        this.loadingComments = true
        try {
          let request = await this.$api.advService.getComments(this.advPk)
          this.comments = request.data
        } catch (e) {
          console.log(e)
        } finally {
          this.loadingComments = false
        }
      },
      saveSalePrice () {
        this.modification = false
        this.saveAdv()
      },
      removeSellerShare (share) {
        this.save = true
        this.$api.advService.deleteShare(this.adv.pk, share.seller).then(res => {
          this.save = false
          this.updateCom()
        }).catch(err => {
          this.handleError(err)
        })
      },
      addSeller (seller) {
        let share = {
          seller: seller.pk,
          remuneration: 0
        }
        this.save = true
        this.$api.advService.postShare(this.adv.pk, share).then(res => {
          this.save = false
          this.shares.push(res.data)
          let sharesPk = this.shares.map(x => x.pk)
          this.adv.co_sellers = sharesPk
          this.$nextTick(() => {
            this.commitAdv(this.adv)
          })
        }).catch(err => {
          this.save = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout du vendeur'
          })
          console.log(err)
        })
      },
      openSellerSelection () {
        let params = {
          excludes: this.sellersPk
        }
        this.$store.commit('setQuickview', { mode: 'SELLER_SELECTION', params: params })
      },
      goToTauxDeCom () {
        this.$router.push({ name: 'Commercialisation', params: { id: this.advPk } })
      },
      goContrat () {
        this.$router.push({ name: 'ContratDeReservation', params: { id: this.advPk, go: 'contrat' } })
      },
      goFinancement () {
        this.$router.push({ name: 'Financement', params: { id: this.advPk, go: 'financement' } })
      },
      goToDoc () {
        this.$router.push({ name: 'AdvDocuments', params: { id: this.advPk } })
      },
      fileChange (files) {
        this.loading = false
        this.uploaded = false
        for (let i = 0; i < files.length; i++) {
          let file = files[i]
          this.files.append('file[]', file, file.name)
        }
        this.upload()
      },
      async upload (e = null) {
        let files
        if (e !== null) files = e
        else files = this.files
        this.uploadingNumber = files.length
        this.loading = true
        let config = {
          onUploadProgress: progressEvent => {
            this.progressData = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
          }
        }
        try {
          let res = await this.$fus.post({ data: files, config })
          let hostedFiles = res.data.slice()
          hostedFiles = hostedFiles.map(x => {
            return {
              fus_id: x.id,
              cloudinary_id: x.cloudinary_id,
              cloudinary_version: x.cloudinary_version,
              path: x.path,
              filename: x.filename,
              display: x.display || true
            }
          })
          this.loading = false
          this.uploaded = true
          if (files.cropped) {
            hostedFiles.cropped = true
            hostedFiles.croppedIndex = this.selectedIndex
          }
          this.uploadDocument(hostedFiles)
          this.reset()
        } catch (e) {
          this.loading = false
        }
      },
      uploadDocument (data) {
        this.adv.mandat_de_gestion_file = data[0]
        this.$emit('pendingEdition', true)
        this.commitAdv(this.adv)
        this.$notify({
          type: 'is-success',
          text: 'Le document à été téléchargé avec succès'
        })
      },
      openBuyerSelection () {
        let buyers = this.coBuyers.concat([this.buyer])
        let buyersPk = buyers.map(x => x.pk)
        let params = {
          excludes: buyersPk
        }
        this.$store.commit('setQuickview', { mode: 'CONTACT_SELECTION', params: params })
      },
      addressContactIsValid (address) {
        if (this.currentUserCountry === 'FRA') {
          return address !== null && address !== '' &&
          address.line1 !== null && address.line1 !== '' &&
          address.zip_code !== null && address.zip_code !== '' &&
          address.city !== null && address.city !== ''
        } else {
          return address !== null && address !== '' &&
            address.zip_code !== null && address.zip_code !== '' &&
            address.city !== null && address.city !== ''
        }
      },
      checkCompleteBuyer (buyer) {
        if (!buyer) return
        if (buyer.nature === 'corporation') {
          return (buyer.corporation_name !== null || buyer.corporation_name !== '') &&
            (buyer.corporation_siret !== null || buyer.corporation_siret !== '') &&
            buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            this.addressContactIsValid(buyer.address) &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '')
        } else {
          return buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            this.addressContactIsValid(buyer.address) &&
            buyer.birthday !== null && buyer.birthday !== '' &&
            buyer.nationality !== null && buyer.nationality !== '' &&
            buyer.birthplace !== null && buyer.birthplace !== '' &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '') &&
            (buyer.family_situation === 'married'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') : true) &&
            (buyer.family_situation === 'pacs'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') : true)
        }
      },
      addCoBuyer (buyer) {
        this.$emit('pendingEdition', true)
        this.coBuyers.push(buyer)
        let adv = Object.assign({}, this.adv)
        adv.co_buyers = this.coBuyers.map(x => {
          if (isObject(x) && 'pk' in x) {
            return x.pk
          } else {
            return x
          }
        })
        this.commitAdv(adv)
      },
      removeCoBuyer (buyer) {
        remove(this.coBuyers, x => x.pk === buyer.pk)
        let adv = Object.assign({}, this.adv)
        adv.co_buyers = this.coBuyers.length ? this.coBuyers.map(x => x.pk) : []
        this.commitAdv(adv)
      },
      beforeRemove (val) {
        this.$swal({
          title: 'Acquéreur',
          text: 'Souhaitez-vous vraiment retirer cet acquéreur ?',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          cancelButtonColor: '#ff0200',
          showCloseButton: true
        }).then(res => {
          console.log(res)
          if (res.value) {
            this.removeCoBuyer(val)
          }
        })
      },
      async addComment () {
        let data = {
          message: this.newCommentMessage
        }
        let request = await this.$api.advService.postComment(this.advPk, data)
        this.comments.push(request.data)
        this.newCommentMessage = null
        this.showNewCommentEditor = false
      },
      async editAdvComment (commentPk, data) {
        let request = await this.$api.advService.patchComment(this.advPk, commentPk, data)
        const index = this.comments.findIndex(x => x.pk === commentPk)
        if (index > -1) {
          this.$set(this.comments, index, request.data)
          const ref = `comment-${commentPk}`
          this.$refs[ref][0].closeEditor()
        } else {
          await this.loadComments()
        }
      },
      async removeAdvComment (commentPk) {
        await this.$api.advService.deleteComment(this.advPk, commentPk)
        this.loadComments()
      },
      openCommentEditor () {
        this.showNewCommentEditor = true
        this.$nextTick(() => {
          let wysiElem = document.getElementsByClassName('ql-editor ql-blank')
          wysiElem = wysiElem[0]
          wysiElem.setAttribute('contenteditable', 'true')
          wysiElem.focus()
        })
      }
    },
    created () {
      this.files = new FormData()
      if (this.adv.mandat_de_gestion) this.$set(this, 'mandatDeGestion', this.adv.mandat_de_gestion)
      this.loadComments()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/Details/AdvInfos.vue